(() => {
    let gcr_form_exists = document.querySelector(".sample_gcr_form")
    let rmoFormSelection = document.getElementById('rmo-form')
    let carfFormSelection = document.getElementById("carf-form")
    let countryCodeList = document.getElementById('country-code-list')
    const globalReceiver = document.getElementById('rc-form')
    const addBankSelection = document.getElementById("addBank")
    const whatsappOptinSeleciton = document.getElementById('whatsappOptin')
    const fullRegistrationSelection = document.getElementById('fullRegistration')
    const otpScreen = document.getElementById('otpScreenContainer')
    const mrBeastMain = document.getElementById('mrBeastMain')
    const mrBeastReceiver = document.getElementById('mrBeastReceiver')
    const mrBeastSuccess = document.getElementById('mrBeastSuccess')
    const moneyOrderEl = document.querySelector('#rmo-money-order')
    const mexicoComplaintForm = document.getElementById("mexico-form-complaint");
    const moneyOrderRefundEl = document.querySelector('#rmo-steps');
    if (
      Boolean(carfFormSelection) ||
      Boolean(rmoFormSelection) ||
      Boolean(gcr_form_exists) ||
      Boolean(countryCodeList) ||
      Boolean(globalReceiver) ||
      Boolean(addBankSelection) ||
      Boolean(whatsappOptinSeleciton) ||
      Boolean(fullRegistrationSelection) ||
      Boolean(mrBeastMain) ||
      Boolean(mrBeastReceiver) ||
      Boolean(mrBeastSuccess) ||
      Boolean(moneyOrderEl) ||
      Boolean(mexicoComplaintForm)||
      Boolean(otpScreen)||
      Boolean(moneyOrderRefundEl)
    ) {
      const formLoadEvent = new CustomEvent("formLoadEvent");
      document.dispatchEvent(formLoadEvent);
    }
})()